let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("apdMw")).then(() => parcelRequire('3M9k7'));